"use client";

import type { ReactNode } from "react";

import {
    MessageContentPanel,
    hasAssistantMessageBody,
} from "@/components/command-team-v2/panels/message-content-panel";
import type { ProtoChatMessage } from "@/components/command-team-v2/prototype/types";
import type { CommandV2ThreadMessage } from "@/components/command-team-v2/types";
import { cn } from "@/lib/utils";

type CommandV2AssistantRowMessage = Pick<
    ProtoChatMessage | CommandV2ThreadMessage,
    | "id"
    | "content"
    | "streamError"
    | "contentSegments"
    | "tools"
    | "pending"
    | "attachedFiles"
>;

interface CommandV2AssistantMessageRowProps {
    message: CommandV2AssistantRowMessage;
    className?: string;
    footer?: ReactNode;
}

export function CommandV2AssistantMessageRow({
    message,
    className,
    footer,
}: CommandV2AssistantMessageRowProps) {
    if (!hasAssistantMessageBody(message)) return null;

    return (
        <div className={cn("min-w-0", className)}>
            <div className="min-w-0 pt-1">
                <MessageContentPanel
                    messageId={message.id}
                    content={message.content}
                    streamError={message.streamError}
                    contentSegments={message.contentSegments}
                    tools={message.tools}
                    isStreaming={message.pending}
                />
                {footer}
            </div>
        </div>
    );
}
